import { render, staticRenderFns } from "./MeetingSummary.vue?vue&type=template&id=493e1424&"
import script from "./MeetingSummary.vue?vue&type=script&lang=js&"
export * from "./MeetingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports